import * as React from 'react';
import { inject, observer } from 'mobx-react';
import * as moment from 'moment';
import styled from 'styled-components';
import { colors } from 'kaizen-ui-colors/lib';
import Layout, * as Area from './ExperienceTableGridLayout';
import { HelpTip } from './HelpTip';
import { IStore } from '../../domain/store';

interface IProps {
  store?: IStore;
}

const TableCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 6px 12px;
  height: 100%;
  color: #fff;
  font-weight: 700;
  background-color: ${colors.metal_dark__626e8b};
  white-space: break-spaces;
`;

const TableCellInner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: break-spaces;
`;

@inject('store')
@observer
export class ExperienceTableHeader extends React.Component<IProps, {}> {
  private store: IStore;

  constructor(props: IProps) {
    super(props);
    this.store = props.store!;
  }

  public render() {
    const { portfolioReportStore } = this.store;
    return (
      <div style={{ position: 'sticky', top: 0, zIndex: 1 }}>
        <Layout>
          <Area.Experience>
            <TableCell style={{ alignItems: 'flex-start' }}>エクスペリエンス</TableCell>
          </Area.Experience>
          <Area.CvCoverage>
            <TableCell>
              <TableCellInner>
                CVカバレッジ
                <HelpTip text="エクスペリエンスを経由して発生したCVが、サイト全体のCVに対してどれくらいの比率かを表す指標。この数字が高いほど、ページを改善した際のCVリフトアップが大きくなる。" />
              </TableCellInner>
            </TableCell>
          </Area.CvCoverage>
          <Area.Status>
            <TableCell>ステータス</TableCell>
          </Area.Status>
          <Area.ImprovementRate>
            <TableCell>
              <TableCellInner>
                改善率
                <HelpTip text="デザイン案の中で最も高いCVRをベースデザイン案のCVRで割った数字" />
              </TableCellInner>
            </TableCell>
          </Area.ImprovementRate>
          <Area.AverageCv>
            <TableCell>平均CV/日</TableCell>
          </Area.AverageCv>
          <Area.AverageVisit>
            <TableCell>平均Visit/日</TableCell>
          </Area.AverageVisit>
          <Area.AverageCvr>
            <TableCell>平均CVR</TableCell>
          </Area.AverageCvr>
          <Area.RoundTimeline>
            <TableCell>
              <TableCellInner>
                ラウンド実施状況
                <HelpTip text="開始日と終了日が同日のラウンドは省略されています" />
              </TableCellInner>
              <div style={{ fontWeight: 500 }}>
                （{moment(portfolioReportStore.portfolioReport.from).format('YYYY/MM/DD')} -{' '}
                {moment(portfolioReportStore.portfolioReport.to).format('YYYY/MM/DD')}）
              </div>
            </TableCell>
          </Area.RoundTimeline>
        </Layout>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/presentation/component/ExperienceTableHeader.tsx